module.exports = __webpack_public_path__ + "img/discovirtual-icon.df2140b1.svg";